var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScissors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1006_40126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03353 5.36666C8.2752 4.84999 8.38353 4.25833 8.31686 3.62499C8.15853 2.18333 7.03353 0.958328 5.60019 0.716661C3.29186 0.316661 1.31686 2.29166 1.71686 4.59166C1.96686 6.02499 3.18353 7.14999 4.6252 7.30833C5.25853 7.37499 5.84186 7.26666 6.36686 7.02499L8.33353 9L6.36686 10.9667C5.85019 10.725 5.25853 10.6167 4.6252 10.6833C3.18353 10.8417 1.95853 11.9667 1.71686 13.4C1.31686 15.7083 3.29186 17.675 5.59186 17.275C7.0252 17.025 8.1502 15.8083 8.30853 14.3667C8.3752 13.7333 8.26686 13.15 8.0252 12.625L10.0002 10.6667L16.3252 16.9917C17.0669 17.7333 18.3335 17.2083 18.3335 16.1583V16.15C18.3335 15.8417 18.2085 15.5417 17.9919 15.3167L8.03353 5.36666ZM5.0002 5.66666C4.08353 5.66666 3.33353 4.92499 3.33353 3.99999C3.33353 3.07499 4.08353 2.33333 5.0002 2.33333C5.91686 2.33333 6.66686 3.07499 6.66686 3.99999C6.66686 4.92499 5.91686 5.66666 5.0002 5.66666ZM5.0002 15.6667C4.08353 15.6667 3.33353 14.925 3.33353 14C3.33353 13.075 4.08353 12.3333 5.0002 12.3333C5.91686 12.3333 6.66686 13.075 6.66686 14C6.66686 14.925 5.91686 15.6667 5.0002 15.6667ZM10.0002 9.41666C9.76686 9.41666 9.58353 9.23333 9.58353 9C9.58353 8.76666 9.76686 8.58333 10.0002 8.58333C10.2335 8.58333 10.4169 8.76666 10.4169 9C10.4169 9.23333 10.2335 9.41666 10.0002 9.41666ZM16.3252 1.00833L10.8335 6.49999L12.5002 8.16666L17.9919 2.67499C18.2085 2.45833 18.3335 2.15833 18.3335 1.84166V1.83333C18.3335 0.791661 17.0669 0.266661 16.3252 1.00833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1006_40126",
    x: 0.665039,
    y: 0.660828,
    width: 18.6685,
    height: 18.678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1006_40126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1006_40126",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScissors);
export default __webpack_public_path__ + "static/media/icon-scissors.aafcafc22f16359d92cb927515813561.svg";
export { ForwardRef as ReactComponent };